export default {
  title: 'Download our app!',
  text: "We have created our own app which makes it extra easy to book with us. Download the app and book your Padel court within a few minutes.",
  appName:"The app is called",
  skip: 'Skip'
}